import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MkpItemAttributeSetLinkContainerModel } from '../../../../../../models';
import { Core2Config } from '../../shared';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';

@Injectable({ providedIn: 'root' })
export class MkpItemAttributeSetLinkService extends BaseApiTemplateService<MkpItemAttributeSetLinkContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + 'item-attribute-set-links/login-entity-ep';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + 'item-attribute-set-links/login-entity-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + 'item-attribute-set-links/login-entity-ep';
        this.httpClient = http;
      }
}



 